/**
 * O'zbek lotinchasidan kirillchaga o'girish.
 *
 * TOZA funksiya — bazasiz test qilinadi (docs/03-CONVENTIONS.md §8).
 *
 * NIMA UCHUN AVTOMATIK: kirillcha bazada alohida maydon sifatida
 * SAQLANMAYDI. Aks holda mijoz butun saytni (sahifalar, 31 blok,
 * mahsulotlar, menyu) ikkinchi marta kiritishi kerak bo'lardi va
 * ikki nusxa vaqt o'tib bir-biridan uzoqlashardi — lotinchasi
 * tahrirlanib, kirillchasi eski holida qolardi.
 *
 * O'girish `resolveTranslation()` ichida, KO'RSATISH paytida bajariladi.
 */
/**
 * TEGILMAYDIGAN bo'laklar.
 *
 * Har biri ataylab:
 *   - `<...>` — HTML teglari. Kontent TipTap dan HTML bo'lib keladi va
 *     tegning o'zi o'girilsa `<p>` `<р>` ga aylanib, sahifa buzilardi
 *   - `&...;` — HTML mnemonikalari (`&nbsp;`)
 *   - `{...}` — interfeys matnlaridagi o'rinbosarlar (`{count}`).
 *     O'girilsa `next-intl` kalitni topa olmasdi
 *   - manzillar va e-pochta — `geoic.uz` «геоиc.уз» ga aylanmasin
 */
const PROTECTED = /(<[^>]*>|&[a-zA-Z#0-9]+;|\{[^{}]*\}|https?:\/\/\S+|www\.\S+|[^\s<>{}]+@[^\s<>{}]+\.[^\s<>{}]+|\b[A-Za-z][A-Za-z0-9-]*\.(?:uz|com|ru|org|net|io|dev)\b)/g;
/** Lotinchadagi apostrof ko'rinishlari — hammasi bittaga keltiriladi. */
const APOSTROPHES = /[‘’ʻʼ`´]/g;
/*
  `o'` va `g'` OLDINDAN ajratiladi.

  Sabab: `yo'l` so'zida `yo` ham digraf (ё), `o'` ham digraf (ў).
  Chapdan o'qilsa `yo` birinchi bo'lib mos keladi va natija «ёъл»
  bo'lardi. To'g'ri javob — «йўл». Shuning uchun `o'` va `g'` avval
  bitta xizmat belgisiga almashtiriladi va digraflar ularni
  ko'rmaydi.
*/
const OQ_LOWER = '\u0001';
const OQ_UPPER = '\u0002';
const GQ_LOWER = '\u0003';
const GQ_UPPER = '\u0004';
const PLACEHOLDERS = {
    [OQ_LOWER]: 'ў',
    [OQ_UPPER]: 'Ў',
    [GQ_LOWER]: 'ғ',
    [GQ_UPPER]: 'Ғ',
};
/**
 * Uzun birikmalar — digraflardan ham OLDIN tekshiriladi.
 *
 * RUSCHADAN O'ZLASHGAN so'zlar o'zbek lotinchasida boshqacha
 * yoziladi va harfma-harf o'girilsa xato chiqadi:
 *
 *   - «ц» — lotinchada `ts` yoki `ks`: `innovatsiya` → «инновация»,
 *     `funksiya` → «функция»
 *   - «ъ» va «ь» — lotinchada UMUMAN yozilmaydi: `obyekt` →
 *     «объект», `relyef` → «рельеф»
 *
 * Qoida ATAYLAB tor. `ts` va `ks` ning o'zi o'girilmaydi: o'zbekcha
 * so'zlarda ular haqiqiy `t`+`s` va `k`+`s` bo'ladi (`ketsa` →
 * «кетса», `aksessuar` → «аксессуар»). Faqat o'zbekchada
 * uchramaydigan ketma-ketliklar sanab o'tilgan.
 *
 * Ro'yxat saytdagi butun matn bo'yicha tekshirilgan: `-tsiya`
 * (7 ta so'z), `-ksiya`/`-ksion` (2 ta), `obyekt` (5 ta), `relyef`.
 * Yangi so'z uchrasa shu yerga qo'shiladi.
 */
const SEQUENCES = [
    ['tsiya', 'ция'],
    ['tsion', 'цион'],
    ['ksiya', 'кция'],
    ['ksion', 'кцион'],
    ['obyekt', 'объект'],
    ['subyekt', 'субъект'],
    ['relyef', 'рельеф'],
];
/** Ikki harfli birikmalar — bir harflilardan OLDIN tekshiriladi. */
const DIGRAPHS = {
    sh: 'ш',
    ch: 'ч',
    yo: 'ё',
    yu: 'ю',
    ya: 'я',
    ye: 'е',
};
const LETTERS = {
    a: 'а',
    b: 'б',
    d: 'д',
    e: 'е',
    f: 'ф',
    g: 'г',
    h: 'ҳ',
    i: 'и',
    j: 'ж',
    k: 'к',
    l: 'л',
    m: 'м',
    n: 'н',
    o: 'о',
    p: 'п',
    q: 'қ',
    r: 'р',
    s: 'с',
    t: 'т',
    u: 'у',
    v: 'в',
    x: 'х',
    y: 'й',
    z: 'з',
    /*
      `c` va `w` o'zbek lotin alifbosida YO'Q — ular faqat chet el
      nomlarida uchraydi (`Mavic`). Lotincha qoldirilsa kirill matn
      ichida yamoq bo'lib ko'rinardi.
    */
    c: 'к',
    w: 'в',
};
/**
 * `e` qachon «э» bo'ladi.
 *
 * So'z boshida (`Erkin` → `Эркин`, `elektr` → `электр`) VA unlidan
 * keyin (`aerofototasvir` → `аэрофототасвир`). Undoshdan keyin —
 * «е» (`kelajak` → `келажак`).
 *
 * Undoshdan keyingi holat uchun `ye` yoziladi (`Abdullayev` →
 * `Абдуллаев`) va u digraf sifatida alohida hal qilinadi.
 */
const HARD_E = 'э';
/** Kirill unlilari — `e` dan OLDIN chiqqan harf shu ro'yxatda bo'lsa «э». */
const CYRILLIC_VOWELS = new Set('аеёиоуўэюяАЕЁИОУЎЭЮЯ');
/**
 * O'ZBEKCHA qisqartmalar — kirillda ham qisqartma bo'ladi.
 *
 * Bosh harfli qisqartmalar odatda lotincha qoldiriladi (DJI, VTOL),
 * lekin o'zbekcha qisqartma bunday emas: jonli saytda «ДУК
 * «Геоинновация маркази»» o'rniga «DUK ...» chiqib turgan edi.
 *
 * Yangi qisqartma uchrasa shu ro'yxatga qo'shiladi — teskarisi
 * (chet el qisqartmalarini sanash) cheksiz ro'yxat bo'lardi.
 */
const UZBEK_ABBREVIATIONS = new Set(['duk', 'aj', 'mchj', 'oav', 'vm', 'xk']);
/**
 * O'girilmaydigan so'z.
 *
 * Chet el qisqartmasi (DJI, VTOL, FPV, RTK) va model raqami
 * (M350, V4, IP55) kirillda ham lotincha yoziladi — ular kirillda
 * tanib bo'lmas holga kelardi.
 *
 * Uzunligi 5 dan oshsa qisqartma emas, oddiy so'z deb qaraladi —
 * `XIZMATLARIMIZ` kabi bosh harfli sarlavha o'girilmay qolmasin.
 */
function isKeptAsIs(word) {
    if (/\d/.test(word))
        return true;
    if (UZBEK_ABBREVIATIONS.has(word.toLowerCase()))
        return false;
    return word.length <= 5 && word === word.toUpperCase() && /[A-Z]/.test(word);
}
/** Natijaga manba so'zning bosh harf holatini qaytaradi. */
function applyCase(source, result) {
    if (source.length > 1 && source === source.toUpperCase())
        return result.toUpperCase();
    if (source[0] !== source[0]?.toLowerCase()) {
        return result.charAt(0).toUpperCase() + result.slice(1);
    }
    return result;
}
/** Bitta lotincha so'zni kirillga o'giradi. */
function convertWord(word) {
    if (isKeptAsIs(word))
        return word;
    // 1-qadam: `o'` va `g'` xizmat belgilariga
    let text = '';
    for (let i = 0; i < word.length; i += 1) {
        const ch = word[i];
        const next = word[i + 1];
        if (next === "'" && (ch === 'o' || ch === 'O' || ch === 'g' || ch === 'G')) {
            const upper = ch === ch.toUpperCase();
            text +=
                ch.toLowerCase() === 'o' ? (upper ? OQ_UPPER : OQ_LOWER) : upper ? GQ_UPPER : GQ_LOWER;
            i += 1;
            continue;
        }
        text += ch;
    }
    // 2-qadam: digraflar va harflar
    let out = '';
    let atWordStart = true;
    for (let i = 0; i < text.length; i += 1) {
        const ch = text[i];
        const placeholder = PLACEHOLDERS[ch];
        if (placeholder) {
            out += placeholder;
            atWordStart = false;
            continue;
        }
        const sequence = SEQUENCES.find(([latin]) => text.slice(i, i + latin.length).toLowerCase() === latin);
        if (sequence) {
            const [latin, cyrillic] = sequence;
            out += applyCase(text.slice(i, i + latin.length), cyrillic);
            i += latin.length - 1;
            atWordStart = false;
            continue;
        }
        const pair = text.slice(i, i + 2);
        const digraph = DIGRAPHS[pair.toLowerCase()];
        if (digraph && pair.length === 2) {
            out += applyCase(pair, digraph);
            i += 1;
            atWordStart = false;
            continue;
        }
        const lower = ch.toLowerCase();
        if (lower === 'e' && (atWordStart || CYRILLIC_VOWELS.has(out.slice(-1)))) {
            out += applyCase(ch, HARD_E);
            atWordStart = false;
            continue;
        }
        if (lower === "'") {
            // Tutuq belgisi — `sanʼat` → `санъат`
            out += 'ъ';
            atWordStart = false;
            continue;
        }
        const letter = LETTERS[lower];
        out += letter ? applyCase(ch, letter) : ch;
        atWordStart = false;
    }
    return out;
}
/** Matndagi lotincha so'zlarni o'giradi, qolganini tegmay qoldiradi. */
function convertSegment(segment) {
    return segment.replace(/[A-Za-z'][A-Za-z'\d]*/g, (word) => convertWord(word));
}
/**
 * O'zbek lotinchasidagi matnni kirillchaga o'giradi.
 *
 * HTML, manzil va `{o'rinbosar}` lar tegilmaydi. Kirillcha matn
 * (masalan ruscha) o'zgarishsiz qaytadi — funksiya faqat lotin
 * harflariga tegadi, ya'ni ikki marta chaqirilsa ham natija bir xil.
 */
export function latinToCyrillic(text) {
    if (!text)
        return text;
    return text
        .replace(APOSTROPHES, "'")
        .split(PROTECTED)
        .map((part, index) => (index % 2 === 1 ? part : convertSegment(part)))
        .join('');
}
//# sourceMappingURL=cyrillic.js.map